import React from 'react';
import { observer } from 'mobx-react';
import { withNamespaces, Trans } from 'react-i18next';

import { Modal } from 'apps/modals/views/modal';
import { ModalContent } from 'apps/modals/styles';

import FileFormatsTable from 'apps/home/fileFormats/fileFormatsTable';

import { ModalTitleWrapper } from 'apps/modals/fileFormatsTable/styles';

@withNamespaces()
@observer
export default class FileFormatsTableModal extends Modal {
  render() {
    return (
      <>
        <ModalTitleWrapper>
          <Trans>Supported file formats.</Trans>
        </ModalTitleWrapper>
        <ModalContent>
          <FileFormatsTable />
        </ModalContent>
      </>
    );
  }
}
